export const getClientes = ({ clientes }) => clientes;
export const getPagination = ({ pagination }) => pagination;
